export default __webpack_public_path__ + "static/media/Korhal_Carnage_Knockout.8cef35e8.jpg";